<div class="header-bar">
  <h1>Supplier Unassignment Report</h1>
</div>
<div class="">
  <div class="">
    <div class="content-container">
      <div class="">
        <form (ngSubmit)="search()" style="width: 100%">
          <div class="ui-g filterPanel">
            <div class="ui-g-12 ui-md-6 ui-lg-3">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.unassignedDateFrom.value"
                  name="unassignedDateFrom"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Unassigned Date From</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-6 ui-lg-3">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.unassignedDateTo.value"
                  name="unassignedDateTo"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label>Unassigned Date To</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-6 ui-lg-3">
              <div class="ui-g-3">
                <label>Customer</label>
              </div>
              <div class="ui-g-9">
                <p-dropdown
                  [options]="customers"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  [(ngModel)]="filterVal.filters.customerId.value"
                  name="customers"
                ></p-dropdown>
              </div>
            </div>

            <div class="ui-g-12 ui-md-6 ui-lg-3">
              <div class="ui-g-3">
                <label>Supplier</label>
              </div>
              <div class="ui-g-9">
                <p-dropdown
                  [options]="suppliers"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                  [(ngModel)]="filterVal.filters.supplierId.value"
                  name="suppliers"
                ></p-dropdown>
              </div>
            </div>

            <div class="ui-g-12">
              <button
                pButton
                type="button"
                label="Clear"
                class="ui-button btn-to-right"
                (click)="clearFilter(dt)"
              ></button>
              <button pButton type="submit" label="Search" class="ui-button btn-to-right"></button>
            </div>
          </div>
        </form>
        <h2 class="sub-header-bar">Report</h2>

        <p-table
          #dt
          [value]="page.items"
          [lazy]="true"
          [rows]="10"
          [responsive]="true"
          [paginator]="true"
          rowHover="true"
          resizableColumns="true"
          [totalRecords]="page.total"
          (onLazyLoad)="onGridLazyLoad($event)"
          [hidden]="!isLoaded"
          [rowsPerPageOptions]="[5, 10, 20]"
          [pageLinks]="3"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="unassignedDateTime">Unassigned Date</th>
              <th pSortableColumn="jobNumber">Job</th>
              <th pSortableColumn="orderNumber">Order</th>
              <th pSortableColumn="reason">Reason</th>
              <th pSortableColumn="weight">Weight</th>
              <th pSortableColumn="blameName">Caused</th>
              <th pSortableColumn="customerName">Customer</th>
              <th pSortableColumn="supplierName">Supplier</th>
              <th pSortableColumn="jobUnassignedComment">Comment</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item">
              <td>
                <span>{{ item.unassignedDateTime | date : 'dd/MM/yyyy' }}</span>
              </td>
              <td>{{ item.jobNumber }}</td>
              <td>{{ item.orderNumber }}</td>
              <td>{{ item.reason }}</td>
              <td>{{ item.weight }}</td>
              <td>{{ item.blameName }}</td>
              <td>{{ item.customerName }}</td>
              <td>{{ item.supplierName }}</td>
              <td>{{ item.jobUnassignedComment }}</td>
            </tr>
          </ng-template>
        </p-table>

        <!--- DATATABLE DEPRECATED ---
        <p-dataTabl #dt [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
                     [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
                     [hidden]="!isLoaded" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3">
            <p-column field="unassignedDateTime" header="UnassignedDate" [sortable]="rue">
                <ng-template let-col let-order="rowData" pTemplate="body">
                    <span>{{ order.unassignedDateTime | date:'dd/MM/yyyy' }}</span>
                </ng-template>
            </p-column>
            <p-column field="jobNumber" header="Job" [sortable]="rue"></p-column>
            <p-column field="orderNumber" header="Order" ></p-column>
            <p-column field="reason" header="Reason" [sortable]="rue"></p-column>
            <p-column field="weight" header="Weight" [sortable]="rue"></p-column>
            <p-column field="blameName" header="Caused" [sortable]="rue"></p-column>
            <p-column field="customerName" header="Customer" ></p-column>
            <p-column field="supplierName" header="Supplier" [sortable]="rue"></p-column>
            <p-column field="jobUnassignedComment" header="Comment" ></p-column>
        </p-dataTable>
        --->
      </div>
      <div class="ui-g-12" style="height: 40px; margin-top: 20px">
        <button
          type="button"
          pButton
          icon="fa ui-icon-file-download"
          label="Download"
          class="ui-button btn-to-right"
          (click)="downloadReport()"
          [disabled]="page.total == 0"
        ></button>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
